export enum WorkflowTransitionPhase {
    IDLE = 'idle',
    SAVING = 'saving',
    VALIDATING = 'validating',
    SUCCESS = 'success',
    SAVE_FAILED = 'save-failed',
    VALIDATION_FAILED = 'validation-failed'
}
